import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createBlock as _createBlock, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/image/shouji.png'
import _imports_1 from '../../assets/image/验证码.png'


const _withScopeId = n => (_pushScopeId("data-v-4f8e5aec"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "motai"
}
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "text" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "phone" }, "短信登录", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "yellow" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "black" }, null, -1))
const _hoisted_9 = { class: "login" }
const _hoisted_10 = {
  src: _imports_0,
  alt: "",
  class: "ico1"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  class: "ico2"
}, null, -1))
const _hoisted_12 = {
  key: 1,
  class: "phone-code-button"
}
const _hoisted_13 = { class: "ikonw" }
const _hoisted_14 = {
  key: 0,
  class: "other"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p1" }, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "第三方登录", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p2" }, null, -1))
const _hoisted_18 = [
  _hoisted_15,
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = {
  key: 1,
  class: "img"
}
const _hoisted_20 = /*#__PURE__*/_createStaticVNode("<div class=\"zfb\" data-v-4f8e5aec><i class=\"iconfont icon-alipay\" data-v-4f8e5aec></i><p data-v-4f8e5aec>支付宝登录</p></div><div class=\"wx\" data-v-4f8e5aec><i class=\"iconfont icon-weixin\" data-v-4f8e5aec></i><p data-v-4f8e5aec>微信登录</p></div><div class=\"wb\" data-v-4f8e5aec><i class=\"iconfont icon-xinlangweibo\" data-v-4f8e5aec></i><p data-v-4f8e5aec>微博登录</p></div>", 3)
const _hoisted_23 = [
  _hoisted_20
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_home_head = _resolveComponent("home-head")!
  const _component_slide_verify = _resolveComponent("slide-verify")!
  const _component_slide_container = _resolveComponent("slide-container")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_html_footer = _resolveComponent("html-footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.verifyCode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createVNode(_component_home_head),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_slide_container, { class: "container-verify" }, {
            default: _withCtx(() => [
              (_ctx.verifyCode)
                ? (_openBlock(), _createBlock(_component_slide_verify, {
                    key: 0,
                    ref: "block",
                    l: 42,
                    r: 10,
                    w: 310,
                    h: 170,
                    "slider-text": _ctx.text,
                    accuracy: _ctx.accuracy,
                    imgs: _ctx.verifyImg,
                    onAgain: _ctx.onAgain,
                    onSuccess: _ctx.onSuccess,
                    onFail: _ctx.onFail,
                    onRefresh: _ctx.onRefresh,
                    onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                  }, null, 8, ["slider-text", "accuracy", "imgs", "onAgain", "onSuccess", "onFail", "onRefresh"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createVNode(_component_router_link, {
                to: "/numberlogin",
                class: "number"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("账号登录")
                ]),
                _: 1
              })
            ]),
            _hoisted_7,
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_el_form, {
                model: _ctx.loginForm,
                rules: _ctx.rules,
                ref: "ruleFormRef"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    prop: "mobile",
                    class: "phones"
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("img", _hoisted_10, null, 512), [
                        [_vShow, _ctx.phone]
                      ]),
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.loginForm.mobile,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.loginForm.mobile) = $event)),
                        placeholder: "请输入手机号",
                        class: "phoneimg"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    prop: "code",
                    class: "code"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_11,
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.loginForm.code,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.loginForm.code) = $event)),
                        placeholder: "请输入短信验证码"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      (_ctx.isShow)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "phone-code-button",
                            onClick: [
                              _cache[3] || (_cache[3] = ($event: any) => (_ctx.showVerifyCode(_ctx.ruleFormRef))),
                              _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
                            ]
                          }, " 获取验证码 "))
                        : (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.countShowText), 1))
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_el_form_item, { prop: "agreement" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_checkbox_group, {
                          modelValue: _ctx.loginForm.agreement,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.loginForm.agreement) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_checkbox, {
                              label: "未注册手机号验证后自动登录，且代表您已同意",
                              name: "agreement"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", {
                      class: "terms",
                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.open && _ctx.open(...args)))
                    }, "隐私政策")
                  ]),
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.submitForm(_ctx.ruleFormRef)))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("登录")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model", "rules"]),
              _createVNode(_component_router_link, {
                to: "/sonlogin",
                class: "sonlogin"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("企业子账号登录")
                ]),
                _: 1
              }),
              false
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_18))
                : _createCommentVNode("", true),
              false
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_23))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _createVNode(_component_html_footer)
    ])
  ], 64))
}